import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/classes/User.class';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { StorageService } from 'src/app/services/storage.service';
import { getDefaultLanguage } from 'src/assets/data/languages';

@Component({
  selector: 'sidebar-component',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  activeTab: string;
  language: string;
  collapsed = true;
  server: string;
  user: User;
  isMowaAdmin = false;
  modalActive = false;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private userService: UserService,
    private userApiService: UserApiService,
    private storageService: StorageService,
  ) {}

  async ngOnInit() {
    this.activeTab = this.router.url;
    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.activeTab = e.url;
      }
    });
    this.user = await this.userApiService.getAdmin();
    if (this.user.role === 'mowa_admin') {
      this.isMowaAdmin = true;
      this.server = this.storageService.getJSON('SERVER');
    }
    this.language = getDefaultLanguage(this.user['language']).code;
    this.translate.setDefaultLang(this.language);
  }

  navigate(url: string) {
    this.router.navigateByUrl(url);
  }

  logout() {
    this.userService.logout();
    this.router.navigate(['login']);
  }

  setLanguage(lang: string) {
    this.language = lang;
    this.translate.setDefaultLang(lang);
  }

  setServerByMowaAdmin(iso: string) {
    this.server = iso;
    this.modalActive = true;
    this.userApiService.switchAPI(iso);
    setTimeout(() => {
      this.modalActive = false;
      location.reload();
      this.storageService.removeJSON('TABLE_DATA');
      this.storageService.removeJSON('ACTIVE_TAB');
    }, 2000);
  }

  closeModal() {
    this.modalActive = false;
  }
}
